import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'text-icon-secondary hover:text-icon-hover relative cursor-pointer',
    icon: 'hover:[&>path]:stroke-icon-brand h-full w-full',
    iconRemove: 'hover:[&>path]:stroke-icon-brand h-full w-full',
    loading: 'loading absolute inset-0 m-auto h-4 w-4 opacity-100'
  },
  variants: {
    isActive: {
      true: {
        icon: 'fill-icon-brand [&>path]:stroke-icon-brand',
        iconRemove: ''
      }
    },
    loading: {
      true: {
        base: 'pointer-events-none cursor-default',
        icon: 'opacity-0',
        iconRemove: 'opacity-0'
      },
      false: {
        loading: 'opacity-0'
      }
    }
  },
  defaultVariants: {
    loading: false
  }
});
